<template>
    <div>
      TestingView
    </div>
  </template>
  
  <script>
  
  export default {
    name: 'TestingView',
  
    components: {
    },
  
    data() {
      return {
      }
    },
  
    methods: {
    }
  };
  </script>
  